@if (isLoaded() && !isLoading()) {
  <div class="row g-2 mb-2">
    <div [class]="endpoints().length > 0 && isAdvanced() ? 'col-12 col-xl-6' : 'col-12'">
      <bn-web-ui-card
        data-e2e="APIGuardianCard"
        heading="API Guardian"
        [inputType]="endpoints().length > 0 && isAdvanced() ? 'switch' : undefined"
        [inputValue]="configuration()?.isEnabled"
        [isFullHeight]="true"
        [isInputDisabled]="isUpdatingEnabled() || false"
        (valueChanged)="onConfigChange({ isEnabled: $event })">
        <bn-web-ui-badge
          color="premium"
          contentClass="ms-2"
          heading-after
          size="md"
          >Advanced</bn-web-ui-badge
        >
        <p [class]="endpoints().length === 0 ? 'bn-api-guardian__heading-card__text' : ''">
          Bunny Shield API Guardian protects your APIs with real-time schema validation and basic authentication checks, blocking malicious or unexpected
          behavior before it reaches your origin.
        </p>
        @if (endpoints().length === 0) {
          <div class="bn-api-guardian__heading-card__img">
            <img
              alt="API Guardian"
              src="/assets/web-ui/images/bunny-silas.svg" />
          </div>
        }
      </bn-web-ui-card>
    </div>
    @if (endpoints().length > 0 && isAdvanced()) {
      <div
        class="col-12 col-xl-6"
        [class.bn-disabled-section]="configuration()?.isEnabled === false">
        <bn-web-ui-card
          heading="Rule execution mode"
          [isFullHeight]="true">
          <div class="mb-4">
            <p>Choose whether to log detected threats or block them immediately.</p>
          </div>
          <bn-web-ui-radio-tabs
            [isLoading]="isUpdatingExecutionMode()"
            [items]="executionModeItems"
            [ngModel]="configuration()?.executionMode ?? 0"
            (ngModelChange)="onConfigChange({ executionMode: $event })" />
        </bn-web-ui-card>
      </div>
    }
    @if (endpoints().length > 0 && isAdvanced()) {
      <div
        class="col-12 col-xl-6"
        [class.bn-disabled-section]="configuration()?.isEnabled === false">
        <bn-web-ui-card
          heading="Body Limit Action"
          [isFullHeight]="true">
          <div class="mb-4">
            <p>Control whether to block, log or ignore when the body length exceeds your plan limit.</p>
          </div>
          <bn-web-ui-radio-tabs
            [isLoading]="isUpdatingBodyLimitAction()"
            [items]="actionItems"
            [ngModel]="configuration()?.bodyLimitAction ?? 1"
            (ngModelChange)="onConfigChange({ bodyLimitAction: $event })" />
        </bn-web-ui-card>
      </div>
    }
    @if (endpoints().length > 0 && isAdvanced()) {
      <div
        class="col-12 col-xl-6"
        [class.bn-disabled-section]="configuration()?.isEnabled === false">
        <bn-web-ui-card
          heading="Unmatched Path Action"
          [isFullHeight]="true">
          <div class="mb-4">
            <p>Choose how to handle unknown endpoints. Log, block, or ignore requests not defined in your API schema.</p>
          </div>
          <bn-web-ui-radio-tabs
            [isLoading]="isUpdatingUnmatchedPathAction()"
            [items]="actionItems"
            [ngModel]="configuration()?.unmatchedPathAction ?? 1"
            (ngModelChange)="onConfigChange({ unmatchedPathAction: $event })" />
        </bn-web-ui-card>
      </div>
    }
  </div>
} @else {
  <div class="row g-2 mb-2">
    <div class="col-12">
      <bn-web-ui-card>
        <ngx-skeleton-loader
          appearance="line"
          count="1"
          [theme]="{ 'width.%': 25, 'height.px': 24, 'margin-bottom.px': 16, overflow: 'hidden' }" />
        <ngx-skeleton-loader
          appearance="line"
          count="1"
          [theme]="{ 'width.%': 100, 'height.px': 16, 'margin-bottom.px': 8, overflow: 'hidden' }" />
        <ngx-skeleton-loader
          appearance="line"
          count="1"
          [theme]="{ 'width.%': 70, 'height.px': 16, 'margin-bottom.px': 0, overflow: 'hidden' }" />
      </bn-web-ui-card>
    </div>
  </div>
  <bn-web-ui-card class="mb-2">
    <ngx-skeleton-loader
      appearance="line"
      count="1"
      [theme]="{ 'width.%': 30, 'height.px': 24, 'margin-bottom.px': 16, overflow: 'hidden' }" />
    <div style="height: 260px; background: rgb(244 244 244 / 50%); border-radius: 12px"></div>
  </bn-web-ui-card>
}

@if (endpoints().length === 0 && isLoaded() && !isLoading() && isAdvanced()) {
  <bn-web-ui-card
    class="mb-2"
    heading="Upload OpenAPI Specification">
    <p class="text-300-regular text-dark-6 mb-3">Provide your OpenAPI file to set up automated request validation, rate limiting, and authentication checks.</p>
    <bn-web-ui-upload-file
      [allowMultipleFiles]="false"
      [allowedFileTypes]="['json']"
      [isMultiple]="false"
      [(ngModel)]="openApiFiles"
      (ngModelChange)="onOpenApiFileSelected($event)" />
    @if (openApiFiles.length) {
      <div class="d-flex justify-content-end mt-3">
        <button
          bn-web-ui-button
          itemStyle="primary"
          size="lg"
          (click)="onContinueClick()">
          Continue
        </button>
      </div>
    }
  </bn-web-ui-card>
}

@if (!isAdvanced() && isLoaded() && !isLoading()) {
  <bn-web-ui-card
    class="mb-2 cursor-pointer"
    heading="Upload OpenAPI Specification"
    (click)="showUpgradeModal()">
    <div class="bn-disabled-section">
      <p class="text-300-regular text-dark-6 mb-3">
        Provide your OpenAPI file to set up automated request validation, rate limiting, and authentication checks.
      </p>
      <bn-web-ui-upload-file
        [allowMultipleFiles]="false"
        [allowedFileTypes]="['json']"
        [isMultiple]="false"
        [ngModel]="[]" />
    </div>
  </bn-web-ui-card>
}

@if (endpoints().length > 0 && isLoaded() && !isLoading() && !isUploading() && isAdvanced()) {
  <div [class.bn-disabled-section]="configuration()?.isEnabled === false">
    <div class="d-flex justify-content-end my-2">
      <bn-web-ui-input
        borderRadius="lg"
        itemStyle="primary"
        placeholder="search"
        size="xs"
        [options]="{
          rightAddons: [{ icon: 'magnifying-glass', size: 'xs' }],
        }"
        [(ngModel)]="searchTerm"
        (ngModelChange)="onSearchChange($event)" />
    </div>
    <div class="bn-shield-guardian-table-header text-500-medium px-4 py-2">API Endpoints</div>
    <bn-web-ui-table
      mobileMode="scroll"
      [columns]="tableColumns"
      [noDataOptions]="{
        size: 'lg',
        title: 'No records',
        description: 'Here you will be able to see all your swagger records.',
        height: '210px',
        imageOptions: {
          fileName: 'bunny-debugging.svg',
          height: '221px',
          top: '-11px',
          right: '20px',
          isAbsolute: true,
        },
      }"
      [paginationOptions]="{
        currentPage: currentPage,
        perPage: perPage,
        totalItems: filteredTableData.length,
      }"
      [tableDataSource]="tableData"
      (dropdownClick)="onDropdownClick($event)"
      (linkClicked)="onLinkClicked($event)"
      (pageChange)="onPageChange($event)" />
    <bn-web-ui-card
      class="my-2"
      [noPadding]="true">
      <div class="row g-0">
        <div class="col-12 col-sm-4 p-4">
          <p class="text-400-regular text-dark-7 mb-1">Total Requests Inspected</p>
          <p class="text-700-semi-bold text-bunny-dark mb-0">{{ chartMetrics() ? (chartMetrics()!.total.totalRequestsInspected | number) : '-' }}</p>
        </div>
        <div class="col-12 col-sm-4 p-4">
          <p class="text-400-regular text-dark-7 mb-1">Total Failed Request Validation</p>
          <p class="text-700-semi-bold text-bunny-dark mb-0">{{ chartMetrics() ? (chartMetrics()!.total.totalFailedRequestValidation | number) : '-' }}</p>
        </div>
        <div class="col-12 col-sm-4 p-4">
          <p class="text-400-regular text-dark-7 mb-1">Total Failed Authentication Enforcement</p>
          <p class="text-700-semi-bold text-bunny-dark mb-0">
            {{ chartMetrics() ? (chartMetrics()!.total.totalFailedAuthenticationEnforcement | number) : '-' }}
          </p>
        </div>
      </div>
    </bn-web-ui-card>
    <bn-web-ui-card
      class="my-2"
      heading="API Activity">
      <div class="chart-container position-relative">
        <bn-chart-multi-metric
          [chartConfig]="{
            formatMode: 'metricSymbol',
            seriesColors: ['info', 'danger', 'success'],
            summaryLabels: [
              { key: 'totalRequestsInspected', label: 'Total Requests Inspected', color: 'info' },
              { key: 'totalFailedRequestValidation', label: 'Total Failed Request Validation', color: 'danger' },
              { key: 'totalFailedAuthenticationEnforcement', label: 'Total Failed Authentication Enforcement', color: 'success' },
            ],
          }"
          [data]="chartMetrics()?.chartSeries ?? []" />
        @if (!chartMetrics()?.hasData) {
          <div class="chart-overlay">
            <span>There is no scanning data to show yet.</span>
          </div>
        }
      </div>
    </bn-web-ui-card>
  </div>
}

<bn-web-ui-side-content
  closeConfirmDescription="Closing endpoint settings will <strong>discard any changes made</strong>."
  closeConfirmTitle="Close endpoint settings?"
  [closeConfirm]="endpointFormDirty()"
  [show]="sidebarIsOpen()"
  (closeAction)="handleSidebarOpen(false)">
  @if (selectedEndpoint(); as endpoint) {
    <div class="bn-api-guardian-slideout__header">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center overflow-hidden">
          <bn-web-ui-switch
            class="me-2 flex-shrink-0"
            size="sm"
            [disabled]="isEndpointUpdating()"
            [ngModel]="endpointForm.isEnabled"
            (ngModelChange)="onEndpointToggle($event)" />
          <bn-web-ui-badge
            contentClass="me-2 flex-shrink-0"
            size="sm"
            type="tag"
            [color]="selectedMethodColor() === 'light' ? '' : selectedMethodColor()"
            >{{ endpoint.requestMethod }}</bn-web-ui-badge
          >
          <span class="text-600-regular text-bunny-dark text-truncate">{{ endpoint.requestPath }}</span>
        </div>
      </div>
    </div>
    <div class="bn-api-guardian-slideout__content">
      <bn-web-ui-card
        heading="Endpoint Activity"
        [noShadow]="true">
        <div class="chart-container position-relative">
          <bn-chart-multi-metric
            [chartConfig]="{
              formatMode: 'metricSymbol',
              seriesColors: ['info', 'danger', 'success'],
              summaryLabels: [
                { key: 'totalRequestsInspected', label: 'Total Requests Inspected', color: 'info' },
                { key: 'totalFailedRequestValidation', label: 'Total Failed Request Validation', color: 'danger' },
                { key: 'totalFailedAuthenticationEnforcement', label: 'Total Failed Authentication Enforcement', color: 'success' },
              ],
            }"
            [data]="endpointChartMetrics()?.chartSeries ?? []" />
          @if (!endpointChartMetrics()?.hasData) {
            <div class="chart-overlay">
              <span>There is no endpoint data to show yet.</span>
            </div>
          }
        </div>
      </bn-web-ui-card>
      <bn-web-ui-card
        class="mt-3"
        heading="Schema Validation"
        [noShadow]="true">
        <div class="d-flex align-items-center flex-wrap gap-4 mb-3">
          <bn-web-ui-switch
            label="Validate Request Body"
            size="sm"
            [ngModel]="endpointForm.validateRequestBodySchema"
            (ngModelChange)="endpointForm.validateRequestBodySchema = $event; markFormDirty()" />
          <bn-web-ui-switch
            label="Validate Response Body"
            size="sm"
            [ngModel]="endpointForm.validateResponseBodySchema"
            (ngModelChange)="endpointForm.validateResponseBodySchema = $event; markFormDirty()" />
        </div>
        <bn-web-ui-tabs
          itemStyle="secondary"
          [activeTab]="schemaValidationTab"
          [hasBorder]="false"
          [tabItems]="schemaValidationTabs"
          (activeTabChange)="schemaValidationTab = $event" />
        @if (schemaValidationTab === 0) {
          @if (endpoint.requestBodySchemaYaml) {
            <div class="bn-api-guardian-slideout__code-wrapper mt-3">
              <div class="bn-api-guardian-slideout__code-block">
                <pre><code>{{ endpoint.requestBodySchemaYaml }}</code></pre>
              </div>
            </div>
          }
          @if (!endpoint.requestBodySchemaYaml) {
            <div class="text-300-regular text-dark-6 mt-3">No request body schema available.</div>
          }
        }
        @if (schemaValidationTab === 1) {
          @if (responseBodyStatusCodes().length > 0) {
            <div class="bn-api-guardian-slideout__code-wrapper mt-3">
              <bn-web-ui-tabs
                itemStyle="secondary"
                [activeTab]="responseSchemaTab"
                [hasBorder]="false"
                [tabItems]="responseBodyStatusCodes()"
                (activeTabChange)="responseSchemaTab = $event" />
              <div class="bn-api-guardian-slideout__code-block mt-3">
                <pre><code>{{ getResponseSchema() }}</code></pre>
              </div>
            </div>
          }
          @if (responseBodyStatusCodes().length === 0) {
            <div class="text-300-regular text-dark-6 mt-3">No response body schema available.</div>
          }
        }
      </bn-web-ui-card>
      <bn-web-ui-card
        class="mt-3"
        heading="Authentication Validation"
        inputType="switch"
        [inputValue]="endpointForm.validateAuthorization"
        [noShadow]="true"
        (valueChanged)="endpointForm.validateAuthorization = $event; markFormDirty()">
        @if (authSchemes().length > 0) {
          <div class="text-300-semi-bold text-bunny-dark mb-2">Types</div>
          <div class="bn-api-guardian-slideout__tags-wrapper">
            @for (scheme of authSchemes(); track scheme) {
              <bn-web-ui-badge
                color="blue"
                size="sm"
                type="tag">
                {{ scheme.schemeName }}
              </bn-web-ui-badge>
            }
          </div>
        }
        @if (authSchemes().length === 0) {
          <div class="text-300-regular text-dark-6">No authentication configuration available.</div>
        }
      </bn-web-ui-card>
      <bn-web-ui-card
        class="mt-3"
        heading="Rate Limiting"
        inputType="switch"
        [inputValue]="endpointForm.rateLimitingEnabled"
        [noShadow]="true"
        (valueChanged)="endpointForm.rateLimitingEnabled = $event; markFormDirty()">
        @if (endpointForm.rateLimitingEnabled) {
          <div class="row g-3">
            <div class="col-12 col-sm-4">
              <label class="text-300-semi-bold text-bunny-dark mb-1 d-block">Counter Key</label>
              <bn-web-ui-select
                [class.bn-has-error]="rateLimitingInvalid() && endpointForm.rateLimitingType === null"
                [items]="rateLimitTypeItems()"
                [ngModel]="endpointForm.rateLimitingType"
                [options]="{ placeholder: 'Select Counter Key' }"
                (ngModelChange)="endpointForm.rateLimitingType = $event; markFormDirty(); rateLimitingInvalid.set(false)" />
            </div>
            <div class="col-12 col-sm-4">
              <label class="text-300-semi-bold text-bunny-dark mb-1 d-block">Requests</label>
              <bn-web-ui-input
                placeholder="1000"
                type="number"
                [hasErrorClass]="rateLimitingInvalid() && !endpointForm.rateLimitingRequestCount"
                [ngModel]="endpointForm.rateLimitingRequestCount"
                (ngModelChange)="endpointForm.rateLimitingRequestCount = $event; markFormDirty(); rateLimitingInvalid.set(false)" />
            </div>
            <div class="col-12 col-sm-4">
              <label class="text-300-semi-bold text-bunny-dark mb-1 d-block">Timeframe</label>
              <bn-web-ui-select
                [class.bn-has-error]="rateLimitingInvalid() && endpointForm.rateLimitingTimeframe === null"
                [items]="rateLimitTimeframeItems()"
                [ngModel]="endpointForm.rateLimitingTimeframe"
                [options]="{ placeholder: 'Select Timeframe' }"
                (ngModelChange)="endpointForm.rateLimitingTimeframe = $event; markFormDirty(); rateLimitingInvalid.set(false)" />
            </div>
          </div>
        }
      </bn-web-ui-card>
      <bn-web-ui-card
        class="mt-3"
        heading="Injection Detection"
        [noShadow]="true">
        <div class="bn-api-guardian-slideout__injection-layout">
          <div class="d-flex flex-column gap-3">
            <bn-web-ui-switch
              label="Detect XSS"
              size="sm"
              [ngModel]="endpointForm.detectParameterXss"
              (ngModelChange)="endpointForm.detectParameterXss = $event; markFormDirty()" />
            <bn-web-ui-switch
              label="Detect SQLi"
              size="sm"
              [ngModel]="endpointForm.detectParameterSqli"
              (ngModelChange)="endpointForm.detectParameterSqli = $event; markFormDirty()" />
          </div>
          @if (availableParamItems().length > 0) {
            <div class="flex-grow-1">
              <label class="bn-api-guardian-slideout__injection-label d-block mb-2">Parameters</label>
              <bn-web-ui-select
                size="md"
                [alter]="false"
                [isMinHeight]="true"
                [items]="availableParamItems()"
                [multiple]="true"
                [ngModel]="endpointForm.injectionDetectionParams"
                [options]="{
                  multiple: true,
                  clearable: false,
                  closeOnSelect: false,
                  isSearchable: false,
                  hideName: false,
                  searchPlaceholder: 'Select parameters',
                  showEndSelectedIcon: true,
                  dropdownWidth: '100',
                  minWidth: '100px',
                  showOnlyCount: false,
                  hideClear: true,
                }"
                (ngModelChange)="endpointForm.injectionDetectionParams = $event; markFormDirty()" />
            </div>
          }
        </div>
      </bn-web-ui-card>
      <div class="bn-api-guardian-slideout__save-wrapper mt-3">
        <button
          bn-web-ui-button
          itemStyle="primary"
          size="lg"
          [disabled]="!endpointFormDirty()"
          [loading]="isEndpointUpdating()"
          (click)="onSaveEndpoint()">
          Save Changes
        </button>
      </div>
    </div>
  }
</bn-web-ui-side-content>

@if (endpoints().length > 0) {
  <bn-web-ui-droppable-content
    [allowedFileTypes]="['json']"
    (onDrop)="onOpenApiFileDrop($event)" />
}
